import React from 'react';
import { Link } from 'react-router-dom';
import {Translate, useTranslation} from '../../../../config/TranslationProvider';
import { formatISO, startOfToday } from 'date-fns';
import {useCategories, useInfiniteEvents} from '../../../../api/hooks';
import SectionTitle from '../../../sections/SectionTitle';
import EventsListing from '../../../sections/EventsListing';
import Title from '../../layout/Title';

const HighlightedEventsSection = () => {
    const {
        data: eventGroups,
        isLoading: eventsLoading,
        error: eventsError,
        fetchMore,
        canFetchMore,
        isFetchingMore
    } = useInfiniteEvents({
        'end_date_from': formatISO(startOfToday()),
        'is_highlight': true
    });

    const viewAllEvents = useTranslation('view_all_events');

    const title = useTranslation('event_calender_dresden_elbland');

    const {data: categories, isLoading: categoriesLoading, error: categoriesError} = useCategories();

    if (eventsLoading || categoriesLoading || eventsError || categoriesError) {
        return null;
    }

    return (
        <section className="listing-cards section-bg section-padding">
            <Title>{title}</Title>
            <div className="container">
                <SectionTitle
                    title={<Translate value="highlights" />}
                    content={<Translate value="highlights_description" />}
                />

                <div className="row">
                    <div className="listing-cards-wrapper col-lg-12">
                        <EventsListing
                            type="grid4"
                            eventGroups={eventGroups}
                            fetchMore={fetchMore}
                            canFetchMore={canFetchMore}
                            isFetchingMore={isFetchingMore}
                            categories={categories}
                        />

                        <Link
                            to="/events"
                            className="btn btn-block btn-gradient btn-gradient-two m-top-20"
                            aria-label={viewAllEvents}
                        >
                            <Translate value="show_all" />
                        </Link>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default HighlightedEventsSection;
